import React, { useState } from 'react';
import { Button, Spinner, Alert } from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import { authenticateWithPasskey } from '../../services/passkeyService';
import { isWebAuthnSupported, getWebAuthnErrorMessage } from '../../utils/webauthn';

const PasskeyLogin = ({ onSuccess }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const handlePasskeyLogin = async () => {
    setError(null);

    // Check browser support
    if (!isWebAuthnSupported()) {
      setError('Este navegador no soporta Passkeys. Usa Chrome, Safari o Edge.');
      return;
    }

    setLoading(true);

    try {
      // Authenticate with passkey
      const result = await authenticateWithPasskey();

      // Call success callback if provided
      if (onSuccess) {
        onSuccess(result.user);
      } else {
        // Default: navigate to home
        navigate('/');
        window.location.reload(); // Reload to update auth state
      }
    } catch (err) {
      console.error('Passkey login error:', err);
      const errorMessage = getWebAuthnErrorMessage(err);
      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="passkey-login">
      {error && (
        <Alert color="danger" className="mb-3">
          {error}
        </Alert>
      )}

      <Button
        color="primary"
        outline
        block
        onClick={handlePasskeyLogin}
        disabled={loading || !isWebAuthnSupported()}
        className="d-flex align-items-center justify-content-center"
      >
        {loading ? (
          <>
            <Spinner size="sm" className="me-2" />
            Autenticando...
          </>
        ) : (
          <>
            <span className="me-2">🔐</span>
            Iniciar sesión con Passkey
          </>
        )}
      </Button>

      {!isWebAuthnSupported() && (
        <small className="text-muted d-block mt-2">
          Este navegador no soporta Passkeys
        </small>
      )}

      <style>{`
        .passkey-login .btn-outline-primary {
          border: 2px solid #007bff;
          font-weight: 500;
          transition: all 0.2s;
        }

        .passkey-login .btn-outline-primary:hover:not(:disabled) {
          background-color: #007bff;
          color: white;
          transform: translateY(-1px);
          box-shadow: 0 4px 8px rgba(0, 123, 255, 0.2);
        }

        .passkey-login .btn-outline-primary:disabled {
          opacity: 0.6;
          cursor: not-allowed;
        }
      `}</style>
    </div>
  );
};

export default PasskeyLogin;
